module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAKCAYAAACuaZ5oAAAACXBIWXMAABcRAAAXEQHKJvM/AAAAvUlEQVQoU2OQy2xIAOILQKzw//9/BmpgoFkOQPwAiA0YoIz/QPwBiAMIaSaEgWY0QM0D4QUgAQWoD+CCQCxAyCAsBmM1B5fNIIUGhAxF0hsADQFYSCTA5NAVOiApBOECAgYLAPEENIcpIKvBpWkDkiYQGyPIQD6UQw2SCdgcgc91BUiaQQnBAU0OOUgccJmD0wIkV8JSGQg3oPnuADbfEW0B1BJQkC1AMhRuGSG9RFmAZFECNDjAGYiQehgGAL2RWdzoE+Y2AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/resource/downArrow.png
// module id = 434
// module chunks = 0